/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import {
  OutPublicUserWithTokenDTO,
  OutPublicUserWithTokenDTOFromJSON,
  OutPublicUserWithTokenDTOToJSON,
  PublicLoginDTO,
  PublicLoginDTOFromJSON,
  PublicLoginDTOToJSON
} from "../models";

export interface CallbackRequest {
  token: string;
}

export interface PublicLoginRequest {
  publicLoginDTO: PublicLoginDTO;
}

/**
 *
 */
export class PublicAuthApi extends runtime.BaseAPI {
  /**
   */
  async callbackRaw(
    requestParameters: CallbackRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<OutPublicUserWithTokenDTO>> {
    if (requestParameters.token === null || requestParameters.token === undefined) {
      throw new runtime.RequiredError(
        "token",
        "Required parameter requestParameters.token was null or undefined when calling callback."
      );
    }

    const queryParameters: any = {};

    if (requestParameters.token !== undefined) {
      queryParameters["token"] = requestParameters.token;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/publicUser/auth/login/callback`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, jsonValue => OutPublicUserWithTokenDTOFromJSON(jsonValue));
  }

  /**
   */
  async callback(requestParameters: CallbackRequest, initOverrides?: RequestInit): Promise<OutPublicUserWithTokenDTO> {
    const response = await this.callbackRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async publicLoginRaw(
    requestParameters: PublicLoginRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters.publicLoginDTO === null || requestParameters.publicLoginDTO === undefined) {
      throw new runtime.RequiredError(
        "publicLoginDTO",
        "Required parameter requestParameters.publicLoginDTO was null or undefined when calling publicLogin."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/api/publicUser/auth/login`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: PublicLoginDTOToJSON(requestParameters.publicLoginDTO)
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async publicLogin(requestParameters: PublicLoginRequest, initOverrides?: RequestInit): Promise<void> {
    await this.publicLoginRaw(requestParameters, initOverrides);
  }
}
